<template>
  <section class="py-16 px-4 bg-stone-50 dark:bg-stone-900 border-t border-stone-200 dark:border-stone-700">
    <div class="max-w-6xl mx-auto font-quicksand">
      <div class="text-center mb-12">
        <h2 class="text-3xl font-bold text-stone-800 dark:text-stone-200 mb-3">
          Power User Tips
        </h2>
        <p class="text-lg text-stone-600 dark:text-stone-400 max-w-2xl mx-auto">
          Master the wheel with these helpful features designed to make your experience smoother and more professional.
        </p>
      </div>

      <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
        <!-- Tip 1 -->
        <div
          class="bg-white dark:bg-stone-800 p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-stone-100 dark:border-stone-700">
          <div
            class="w-12 h-12 bg-primary-100 dark:bg-primary-900/30 rounded-full flex items-center justify-center mb-4 text-primary-600 dark:text-primary-400">
            <i class="fas fa-keyboard text-xl"></i>
          </div>
          <h3 class="text-lg font-bold text-stone-800 dark:text-stone-200 mb-2">Shortcut Keys</h3>
          <p class="text-stone-600 dark:text-stone-400 text-sm leading-relaxed">
            Want to keep the flow going? Simply press the <strong>Spacebar</strong> or <strong>Ctrl+Enter</strong> to
            spin the wheel instantly without reaching for the mouse.
          </p>
        </div>

        <!-- Tip 2 -->
        <div
          class="bg-white dark:bg-stone-800 p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-stone-100 dark:border-stone-700">
          <div
            class="w-12 h-12 bg-primary-100 dark:bg-primary-900/30 rounded-full flex items-center justify-center mb-4 text-primary-600 dark:text-primary-400">
            <i class="fas fa-expand text-xl"></i>
          </div>
          <h3 class="text-lg font-bold text-stone-800 dark:text-stone-200 mb-2">Fullscreen Mode</h3>
          <p class="text-stone-600 dark:text-stone-400 text-sm leading-relaxed">
            Presenting to a crowd? Hide the clutter by clicking the fullscreen icon (top right) or pressing
            <strong>F11</strong>. Perfect for classroom projectors.
          </p>
        </div>

        <!-- Tip 3 -->
        <div
          class="bg-white dark:bg-stone-800 p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-stone-100 dark:border-stone-700">
          <div
            class="w-12 h-12 bg-primary-100 dark:bg-primary-900/30 rounded-full flex items-center justify-center mb-4 text-primary-600 dark:text-primary-400">
            <i class="fas fa-wifi text-xl"></i>
          </div>
          <h3 class="text-lg font-bold text-stone-800 dark:text-stone-200 mb-2">Works Offline</h3>
          <p class="text-stone-600 dark:text-stone-400 text-sm leading-relaxed">
            Don't worry about spotty Wi-Fi. Once loaded, Spin the Names works completely offline as a Progressive Web
            App (PWA).
          </p>
        </div>

        <!-- Tip 4 -->
        <div
          class="bg-white dark:bg-stone-800 p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-stone-100 dark:border-stone-700">
          <div
            class="w-12 h-12 bg-primary-100 dark:bg-primary-900/30 rounded-full flex items-center justify-center mb-4 text-primary-600 dark:text-primary-400">
            <i class="fas fa-file-export text-xl"></i>
          </div>
          <h3 class="text-lg font-bold text-stone-800 dark:text-stone-200 mb-2">Import & Export</h3>
          <p class="text-stone-600 dark:text-stone-400 text-sm leading-relaxed">
            Have a list in a spreadsheet? You can paste lists directly into the edit box, or use the Import tool to load
            names from Google Sheets.
          </p>
        </div>
      </div>
    </div>

    <!-- Back to Top link -->
    <div class="text-center mt-12">
      <a href="#" @click.prevent="scrollToTop"
        class="inline-flex items-center px-4 py-2 text-sm font-medium text-primary-600 dark:text-primary-400 hover:text-primary-800 dark:hover:text-primary-300">
        <i class="fas fa-arrow-up mr-2"></i> Back to Top
      </a>
    </div>
  </section>
</template>

<script setup>
// Static content
function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}
</script>
